module.exports = __webpack_public_path__ + "static/media/as3tj0.bf264578.png";